import { styled } from '@aibi-ui/core';
import ImgLogo from 'src/assets/images/login/logo.png';
import ImgBack from 'src/assets/images/login/background.png';
import ImgLeft from 'src/assets/images/login/left.png';
import { useEffect, useState } from 'react';
import { message } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Giflogin from 'src/assets/images/login.gif';
import { Toast } from 'antd-mobile';
import { AntdForm } from '../../components';
import Button from '../../components/Button';
import Icons from '../../components/Icons';
import { postLoginAPI } from '../../api/login';
import getBootstrapData from '../../utils/getBootstrapData';
import isMobile from '../../utils/isMobile';
import TypeWriter from './components/TypeWriter';
import useWindowSize from '../../hooks/useWindowSize';
import { Input } from 'antd'

const LoginStyle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: url(${ImgBack}) no-repeat center center;
  .title {
    position: fixed;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    top: 20px;
    left: 20px;
    img {
      width: 30px;
    }
    .text {
      color: #333333;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
    }
  }
  .main {
    position: relative;
    display: flex;
    justify-content: center;
    gap: 70px;
    .left {
      padding-top: 20px;
      .description {
        .desc-title {
          color: #333;
          font-size: 24px;
          font-weight: 600;
        }
        .desc-sec-title {
          margin-top: 16px;
          color: #2e405d;
          font-size: 20px;
        }
        .tags {
          display: flex;
          justify-content: flex-start;
          align-content: center;
          gap: 8px;
          margin-top: 16px;
          .tag {
            padding: 0 6px;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            border: 1px solid rgba(144, 154, 170, 0.6);
            color: #3b4b67;
            font-size: 16px;
          }
        }
        .color-tag {
          position: relative;
          margin-top: 16px;
          width: 256px;
          height: 32px;
          border-radius: 4px;
          z-index: 0;

          &::before {
            content: '';
            position: absolute;
            inset: 0;
            padding: 1px; // 控制边框粗细
            border-radius: 4px;
            background: linear-gradient(
              90deg,
              rgba(80, 149, 254, 1),
              rgba(174, 123, 254, 1)
            );
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            mask:
              linear-gradient(#fff 0 0) content-box,
              linear-gradient(#fff 0 0);
            mask-composite: exclude;
            pointer-events: none;
            z-index: -1;
          }

          .content {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6px;
            border-radius: 4px;
            background: transparent; // 镂空效果
          }

          .anticon,
          div {
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(0deg, #3b89ff 0%, #a784fe 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            font-size: 16px;
          }

          svg {
            width: 15px;
            height: 15px;
          }
        }

        .image {
          width: 457px;
          transform: translate(-12px, -18px);
        }
      }
    }
    .right {
      .login-form {
        //position: fixed;
        display: flex;
        flex-direction: column;
        //justify-content: center;
        align-items: center;
        padding-top: 82px;
        background: #fff;
        width: 423px;
        height: 534px;
        box-shadow: 0px 2px 17px 0px rgba(168, 177, 191, 0.1);
        border-radius: 14px;
        .text-1 {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 6px;
          width: 330px;
          img {
            width: 30px;
          }
          span {
            color: #333;
            font-size: 24px;
            font-weight: 600;
            letter-spacing: 2px;
          }
        }
        .text-2 {
          margin-top: 18px;
          font-size: 16px;
          color: #3b4b67;
          letter-spacing: 1px;
          width: 330px;
        }
        .form {
          margin-top: 52px;
          width: 330px;
          input:-webkit-autofill {
            -webkit-box-shadow: 0 0 0 1000px #f5f6f8 inset !important;
            box-shadow: 0 0 0 1000px #f5f6f8 inset !important;
          }
          .ant-form-item {
            margin-bottom: 30px;
            .ant-input-affix-wrapper {
              height: 42px;
              background: #f5f6f8;
              border-color: transparent !important;
              border-radius: 6px;
              .ant-input-prefix {
                color: #909aaa !important;
              }
              &:hover {
                border-color: #5687ff !important;
                .ant-input-prefix {
                  color: #5687ff !important;
                }
              }
              .ant-input {
                background: #f5f6f8;
                &::placeholder {
                  color: #909aaa;
                }
              }
            }
            .ant-input-affix-wrapper-focus {
              border-color: #5687ff !important;
              .ant-input-prefix {
                color: #5687ff !important;
              }
            }
          }
          .ant-btn {
            margin-top: 24px;
            width: 100%;
            height: 42px;
            border-radius: 6px;
            font-size: 16px;
          }
        }
      }
    }
  }
`;

const LoginMobileStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  //height: 100vh;
  background: linear-gradient(
    139deg,
    #f4f6ff 0%,
    rgb(255, 255, 255) 20%,
    rgb(255, 255, 255) 63%,
    #f4f6ff 100%
  );
  .wrapper {
    margin: 0 auto;
    .form {
      input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #f5f6f8 inset !important;
        box-shadow: 0 0 0 1000px #f5f6f8 inset !important;
      }
      .ant-form-item {
        margin-bottom: 4.8vw;
        .ant-input-affix-wrapper {
          padding: 4vw 6.4vw;
          height: 14.93vw;
          background: #f5f6f8;
          border-color: transparent !important;
          border-radius: 2.13vw;
          .ant-input-prefix {
            color: #a7bffc !important;
            width: 6.93vw;
            height: 6.93vw;
            svg {
              width: 6.93vw;
              height: 6.93vw;
            }
          }
          .ant-input {
            background: #f5f6f8;
            font-size: 4.27vw;
            &::placeholder {
              padding-left: 1.07vw;
              color: #999;
              font-size: 4.27vw;
            }
          }
        }
      }
      .ant-btn {
        margin-top: 4.8vw;
        width: 100%;
        height: 14.93vw;
        border-radius: 1.6vw;
        font-size: 4.27vw;
        background-color: #007bff;
      }
    }
  }
`;

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [usernameFocus, setUsernameFocus] = useState(false);
  const [placeholderUsername, setPlaceholderUsername] = useState('');
  const [passwordFocus, setPasswordFocus] = useState(false);
  const [placeholderPassword, setPlaceholderPassword] = useState('');
  const { height } = useWindowSize();
  useEffect(() => {
    setPlaceholderUsername(usernameFocus ? '正在输入...' : '请输入学号/工号');
    setPlaceholderPassword(passwordFocus ? '正在输入...' : '请输入密码');
  }, [usernameFocus, passwordFocus]);
  const [loginForm, setLoginForm] = useState({
    username: '',
    password: '',
    csrf_token: null,
  });
  const [loadingButton, setLoadingButton] = useState(false);

  const [mobile, setMobile] = useState(isMobile());

  const onLogin = async () => {
    try {
      if (!loginForm.username) {
        if (mobile) {
          Toast.show('请输入学号/工号');
        } else {
          message.warning('请输入学号/工号');
        }
        return;
      }
      if (!loginForm.password) {
        if (mobile) {
          Toast.show('请输入学号/工号');
        } else {
          message.warning('请输入密码');
        }
        return;
      }
      setLoadingButton(true);
      const { csrf_token } = getBootstrapData();
      try {
        await postLoginAPI({ ...loginForm, csrf_token });
      } catch (error) {
        console.error(error)
      }
      setLoadingButton(false);
      const searchParams = new URLSearchParams(window.location.search);
      if (mobile) {
        window.location.href = `/mobile/chat?${searchParams.toString()}`;
      } else {
        const next = searchParams.get('next');
        if (next) {
          window.location.href = next;
        } else {
          location.reload();
        }
      }
    } catch (e) {
      console.log({ e });
      setLoadingButton(false);
    }
  };

  const renderLoginMobile = () => (
    <LoginMobileStyle style={{ height }}>
      <div className="wrapper w-full px-32 -translate-y-96">
        <div className="relative z-10 h-120">
          <TypeWriter
            text1="你好！"
            text2="我是你的"
            text3="AI数据分析助手"
            className1="mb-12 text-26 text-[#5687ff] font-semibold"
            className2="text-20 text-[#3e4041] leading-32 font-semibold"
            className3="text-20 text-[#3e4041] leading-32 font-semibold"
          />
        </div>
        <div className="relative form mt-30">
          <img src={Giflogin} className="absolute w-196 -top-200 -right-24" />
          <AntdForm>
            <AntdForm.Item name="username">
              <Input
                value={loginForm.username}
                placeholder={placeholderUsername}
                prefix={<Icons.LoginUsername viewBox="0 0 19 18" />}
                suffix={<></>}
                onFocus={() => setUsernameFocus(true)}
                onBlur={() => setUsernameFocus(false)}
                onChange={e =>
                  setLoginForm({ ...loginForm, username: e.target.value })
                }
                onPressEnter={() => onLogin()}
              />
            </AntdForm.Item>
            <AntdForm.Item name="password">
              <Input
                value={loginForm.password}
                type="password"
                placeholder={placeholderPassword}
                prefix={<Icons.LoginPassword viewBox="0 0 19 18" />}
                suffix={<></>}
                onFocus={() => setPasswordFocus(true)}
                onBlur={() => setPasswordFocus(false)}
                onChange={e =>
                  setLoginForm({ ...loginForm, password: e.target.value })
                }
                onPressEnter={() => onLogin()}
              />
            </AntdForm.Item>
          </AntdForm>
          <Button
            buttonStyle="primary"
            loading={loadingButton}
            onClick={onLogin}
            className="text-16 w-full h-56"
          >
            登录
          </Button>
        </div>
      </div>
    </LoginMobileStyle>
  );

  const renderLoginWeb = () => (
    <LoginStyle>
      <div className="title">
        <img src={ImgLogo} alt="" />
        <div className="text">AI数据分析助手</div>
      </div>
      <div className="main">
        <div className="left hidden lg:!block">
          <div className="description">
            <div className="desc-title">AI数据分析助手</div>
            <div className="desc-sec-title">新一代AI数据分析平台</div>
            <div className="tags">
              <div className="tag">权限管理</div>
              <div className="tag">对话式交互</div>
              <div className="tag">多维数据分析</div>
              <div className="tag">智能图表绘制</div>
            </div>
            <div className="color-tag">
              <div className="content">
                <Icons.LoginTag viewBox="0 0 16 16" />
                <div>通过自然语言进行数据分析</div>
              </div>
            </div>
            <img className="image" src={ImgLeft} alt="ai-bi-helper" />
          </div>
        </div>
        <div className="right">
          <div className="login-form">
            <div className="text-1">
              <img src={ImgLogo} alt="ai-bi-helper" />
              <span>欢迎登录</span>
            </div>
            <div className="text-2">请在下面输入您的学号/工号和密码</div>
            <div className="form">
              <AntdForm>
                <AntdForm.Item name="username">
                  <Input
                    value={loginForm.username}
                    className={
                      usernameFocus ? 'ant-input-affix-wrapper-focus' : ''
                    }
                    placeholder={placeholderUsername}
                    prefix={<Icons.LoginUsername viewBox="0 0 19 18" />}
                    suffix={<></>}
                    onFocus={() => setUsernameFocus(true)}
                    onBlur={() => setUsernameFocus(false)}
                    onChange={e =>
                      setLoginForm({ ...loginForm, username: e.target.value })
                    }
                    onPressEnter={() => onLogin()}
                  />
                </AntdForm.Item>
                <AntdForm.Item name="password">
                  <Input.Password
                    value={loginForm.password}
                    type="password"
                    className={
                      passwordFocus ? 'ant-input-affix-wrapper-focus' : ''
                    }
                    placeholder={placeholderPassword}
                    prefix={<Icons.LoginPassword viewBox="0 0 19 18" />}
                    suffix={<></>}
                    onFocus={() => setPasswordFocus(true)}
                    onBlur={() => setPasswordFocus(false)}
                    onChange={e =>
                      setLoginForm({ ...loginForm, password: e.target.value })
                    }
                    onPressEnter={() => onLogin()}
                  />
                </AntdForm.Item>
              </AntdForm>
              <Button
                buttonStyle="primary"
                loading={loadingButton}
                onClick={onLogin}
              >
                登录
              </Button>
            </div>
          </div>
        </div>
      </div>
    </LoginStyle>
  );

  return mobile ? renderLoginMobile() : renderLoginWeb();
};

export default Login;
